/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="13" height="13" viewBox="0 0 13 13" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="m7.74,5.5L12.58,0h-1.15l-4.2,4.78L3.87,0H0l5.08,7.23L0,13h1.15l4.44-5.05,3.54,5.05h3.87l-5.26-7.5h0,0Zm-1.57,1.79l-.51-.72L1.56.84h1.76l3.3,4.62.51.72,4.29,6.01h-1.76l-3.5-4.9h0s0,0,0,0Z" className="icon-fill" fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'XIcon';

export default Icon;
